import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import { useState, useEffect, useContext } from 'react';
import { TrackerContext } from '@uniformdev/tracking-react';
export var useUniformPersonalization = function useUniformPersonalization() {
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    visitor = _useState2[0],
    setVisitor = _useState2[1];
  var _useState3 = useState(undefined),
    _useState4 = _slicedToArray(_useState3, 2),
    visit = _useState4[0],
    setVisit = _useState4[1];
  var _useState5 = useState(undefined),
    _useState6 = _slicedToArray(_useState5, 2),
    tracker = _useState6[0],
    setTracker = _useState6[1];
  var context = useContext(TrackerContext);
  useEffect(function () {
    var unsubs = [];
    unsubs.push(context.subscriptions.subscribe("tracker-set", function (e) {
      if (e.tracker) {
        setTracker(e.tracker);
        unsubs.push(e.tracker.subscribe("tracking-finished", function (e2) {
          if (e2.visitor) {
            setVisitor(e2.visitor);
          }
          if (e2.visit) {
            setVisit(e2.visit);
          }
        }));
      }
    }));
    return function cleanup() {
      unsubs.forEach(function (unsub) {
        return unsub();
      });
    };
  }, []);
  return {
    visitor: visitor,
    visit: visit,
    tracker: tracker
  };
};